import { Component, Input } from '@angular/core';

import { CompletionStatus } from '@completion/enums';

function coerceCompletionStatus(value: unknown): CompletionStatus | null {
  if (value == null) {
    return null;
  }

  if (typeof value === 'string') {
    const v = value.trim().toUpperCase();
    switch (v) {
      case 'OK':
        return CompletionStatus.OK;
      case 'NA':
      case 'N/A':
        return CompletionStatus.NA;
      case 'PA':
        return CompletionStatus.PA;
      case 'PB':
        return CompletionStatus.PB;
      case 'PP':
        return CompletionStatus.PP;
      default:
        return CompletionStatus.OS;
    }
  }

  return null;
}

@Component({
  selector: 'app-discipline-status-circle',
  templateUrl: './discipline-status-circle.component.html',
  styleUrls: ['./discipline-status-circle.component.scss'],
  standalone: false,
})
export class DisciplineStatusCircleComponent {
  @Input({ transform: coerceCompletionStatus }) status: CompletionStatus | null = null;
  @Input() disciplineNumber = '';
  @Input() isOffline = false;

  get statusClass(): string {
    if (this.status == null) {
      return 'status-none';
    }

    return `status-${this.status.toString().toLowerCase()}`;
  }

  get isDisabled(): boolean {
    return this.isOffline || this.status == null;
  }
}
